// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Monitor } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMonitor(props: any) {
    return <IconBase icon={Monitor} {...props} />
  }

  export default IconMonitor
  